"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectFromConfig = exports.initConfig = exports.configReducer = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectSpread2"));

var _reselect = require("reselect");

var _reduxAct = require("redux-act");

var _configBag = _interopRequireDefault(require("@gandi/config-bag"));

function getConfig(state) {
  var configBag = new _configBag.default();
  configBag.merge(state.config);
  return configBag;
}
/**
 * Return the value of the config corresponding to the key `key`.
 * @param  {String} key
 * @param  {Mixed}  defaultValue
 * @return {Mixed}
 */


var selectFromConfig = function selectFromConfig(key, defaultValue) {
  return (0, _reselect.createSelector)(getConfig, function (config) {
    return config.get(key, defaultValue);
  });
};

exports.selectFromConfig = selectFromConfig;
var initConfig = (0, _reduxAct.createAction)('Init configuration');
exports.initConfig = initConfig;
var configReducer = (0, _reduxAct.createReducer)((0, _defineProperty2.default)({}, initConfig.getType(), function (state, payload) {
  return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), payload);
}), {});
exports.configReducer = configReducer;